import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

import Drawer from "src/components/layout/drawer"
import Header from "../components/layout/header"
import { StyledMain } from "../components/layout/main"
import { Box, Container, useTheme } from "@mui/material"
import { useState } from "react"

const MainLayout = ({ children }) => {
  const theme = useTheme()
  const [drawerOpen, onChangeDrawer] = useState(true)
  const [drawerOpenMobile, onChangeDrawerMobile] = useState(false)

  const handleDrawerToggle = () => {
    onChangeDrawer(!drawerOpen)
    onChangeDrawerMobile(!drawerOpenMobile)
  }

  return (
    <div className='pattern-background'>
      <Container maxWidth='lg' sx={{ minHeight: "100vh", px: { xs: 0, sm: 2 } }}>
        <Box sx={{ display: "flex", width: "100%", pt: { xs: 0, md: 3, xl: 5.5 } }}>
          <Drawer
            open={drawerOpen}
            handleDrawerToggle={handleDrawerToggle}
            setDrawer={onChangeDrawerMobile}
            drawerOpenMobile={drawerOpenMobile}
          />
          <StyledMain theme={theme} open={drawerOpen}>
            <Header open={drawerOpen} handleDrawerToggle={handleDrawerToggle} />
            {children}
          </StyledMain>
        </Box>
      </Container>
    </div>
  )
}

export default MainLayout

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
